<template>
    <div>
        <el-breadcrumb class="Breadcrumb" separator="/">
            <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
            <el-breadcrumb-item>招聘会</el-breadcrumb-item>
        </el-breadcrumb>
        <el-divider></el-divider>
        <div class="search">
            <el-row :gutter="24">
                <el-col :span="6" :offset="0">
                    <el-input v-model="search.title" placeholder="请输入招聘会名称"></el-input>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" @click="getListFun(1)" icon="el-icon-search">查询</el-button>
                    <el-button type="primary" @click="openAdd()" icon="el-icon-plus">添加</el-button>
                </el-col>
            </el-row>
        </div>
        <el-divider></el-divider>
        <div class="table">
            <el-table :data="tableData" stripe style="width: 100%">
                <el-table-column prop="title" label="招聘会标题">
                </el-table-column>
                <el-table-column prop="address" label="地址">
                </el-table-column>
                <el-table-column prop="sendStartDate" label="开始时间">
                </el-table-column>
                <el-table-column prop="sendEndDate" label="结束时间">
                </el-table-column>
                <el-table-column prop="isUsed" label="启用/禁用">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.isUsed" active-color="#13ce66" inactive-color="#ff4949"
                            @change="changeDemo(scope.row.id, scope.row.isUsed)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="id" fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button @click="openEdit(scope.row)" type="text" icon="el-icon-edit" size="small">编辑</el-button>
                        <el-button @click="deleteFun(scope.row.id)" type="text" icon="el-icon-delete"
                            size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--分页-->
        <div class="pagination">
            <el-pagination background @size-change="changSizeFun" @current-change="changpageFun"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum">
            </el-pagination>
        </div>

        <!-- 弹窗-->
        <el-dialog :title="popTitle" :visible.sync="pop" width="30%" @close="resetForm('popfrom')"
            :close-on-click-modal="false">
            <el-form :model="formDate" label-width="80px" ref="popfrom" :rules="popRule">
                <el-form-item label="标题" prop="title">
                    <el-input placeholder="请输入标题" v-model="formDate.title" class="input-width"></el-input>
                </el-form-item>
                <el-form-item label="地址" prop="address">
                    <el-input placeholder="请输入地址" v-model="formDate.address" class="input-width"></el-input>
                </el-form-item>
                <el-form-item label="举办时间" prop="sendDate">
                    <el-date-picker v-model="formDate.sendDate" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" class="input-width" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="内容" prop="content">
                    <Fuwenben ref="fuwenben" :htmlData="formDate.content"></Fuwenben>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetForm('popfrom')">取 消</el-button>
                <el-button type="primary" @click="subFun('popfrom')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Fuwenben from '@/components/fuwenben.vue'

export default {
    data() {
        return {
            //加载数据
            typeSelect: [],
            pageSize: 10,
            pageNum: 1,
            totalNum: 0,
            search: {
                title: ''
            },
            //table数据
            tableData: [],
            pop: false,
            popTitle: '',
            formDate: {
                id: '',
                title: '',
                address: '',
                sendDate: [],
                content: '',
            },
            popRule: {
                title: [
                    { required: true, message: '请输入标题', trigger: 'blur' }
                ],
                sendDate: [
                    { required: true, message: '请输入举办时间', trigger: 'change' }
                ],
            }
        }
    },
    components: {
        Fuwenben
    },
    mounted() {
        this.getList();
    },
    methods: {
        openAdd() {
            this.formDate = {
                id: '',
                title: '',
                address: '',
                sendDate: [],
                content: '',
            };
            // this.formDate.content = '';
            // this.$refs.fuwenben.$data.html = "";
            this.popTitle = "添加招聘会";
            this.pop = true;
            this.$nextTick(() => {
                this.$refs.fuwenben.clear();
            })
        },
        openEdit(obj) {
            this.formDate = {
                id: obj.id,
                title: obj.title,
                address: obj.address,
                sendDate: [obj.sendStartDate, obj.sendEndDate],
                content: obj.content,
            };
            this.popTitle = "修改招聘会";
            this.pop = true;
            this.$nextTick(() => {
                this.$refs.fuwenben.clear();
                this.$refs.fuwenben.giveHttp(this.formDate.content);
            })


        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.pop = false
        },
        subFun(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.formDate.content = this.$refs.fuwenben.$data.html;
                    if (!this.formDate.id) {
                        this.addFun();
                    } else {
                        this.editFun();
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        addFun() {
            let data = {
                title: this.formDate.title,
                address: this.formDate.address,
                sendStartDate: this.formDate.sendDate[0],
                sendEndDate: this.formDate.sendDate[1],
                content: this.formDate.content,
            }
            this.$post(api + "/recruitment/addRecruitment", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: '添加成功!'
                    })
                    this.pop = false;
                    this.getListFun(1);
                } else {
                    this.$message.error(res.desc);
                }
            })
        },
        editFun() {
            let data = {
                id: this.formDate.id,
                title: this.formDate.title,
                address: this.formDate.address,
                sendStartDate: this.formDate.sendDate[0],
                sendEndDate: this.formDate.sendDate[1],
                content: this.formDate.content,
            }
            this.$post(api + "/recruitment/editRecruitment", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: '修改成功!'
                    });
                    this.pop = false;
                    this.getListFun(this.pageNum);
                } else {
                    this.$message.error(res.desc);
                }
            })
        },
        //查询列表
        getList() {
            let data = {
                title: this.search.title,
                pageSize: this.pageSize,
                pageNum: this.pageNum,
            }
            this.$get(api + "/recruitment/getList", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.tableData = res.data;
                    this.totalNum = res.totalNum
                }
            })
        },

        //删除User
        deleteFun(row) {
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {}
                this.$post(api + "/recruitment/delete/" + row, data).then(response => {
                    let res = response.data;
                    if (res.code == 0) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.getListFun(1);
                    } else {
                        this.$message.error(res.desc);
                    }
                })
            }).catch(() => {

            });

        },

        //开启/关闭用户
        changeDemo(id, isUsed) {
            //true = 开启 false = 关闭
            let data = {}
            let uri = isUsed ? "enable" : "disable"
            let url = "/recruitment/" + uri + "/" + id;
            this.$post(api + url, data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.getListFun(this.pageNum);
                } else {
                    this.$message.error(res.desc);
                }
            })
        },
        //特定pageNum查询列表
        getListFun(val) {
            this.pageNum = val;
            this.getList();
        },

        //更换pageSize
        changSizeFun(val) {
            console.log(`每页 ${val} 条`);
            this.getListFun(val);
        },
        //翻页
        changpageFun(val) {
            console.log(this.pageNum);
            this.getListFun(val);
        },

    },

}
</script>


<style>
.Breadcrumb {
    _box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}

.input-width {
    width: 100% !important;
}

.el-row {
    margin-bottom: 20px;
}

.el-col {
    border-radius: 0px;
}

.bg-purple-dark {
    background: #99a9bf;
}

.bg-purple {
    background: #d3dce6;
}

.bg-purple-light {
    background: #e5e9f2;
}

.grid-content {
    border-radius: 0px;
    min-height: 36px;
}

.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}

.my-label {
    /* font-weight: bold; */
    font-size: 16px;
    font-weight: 700 !important;
    color: #303133 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/recruit/Recruit.vue